import { portfolio, site } from "@/config/site";
import { SEO, breadcrumbLd } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTA } from "@/components/CTA";
import { Gallery } from "@/components/Gallery";

export default function Projects() {
  return (
    <>
      <SEO
        title="Our Projects | Painting Gallery — North Ember Painting, Delta BC"
        description="Browse painting project concepts: interiors, exteriors, cabinet refinishing, commercial spaces and detail work across Delta, Ladner, Tsawwassen and Surrey."
        path="/projects"
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Our Projects", path: "/projects" }])]}
      />
      <PageHero
        eyebrow="Our projects"
        title="The finish is the whole point"
        intro="A look at the styles and standards we work toward — interiors, exteriors, cabinets, commercial spaces and detail work."
        image="trimMolding"
      />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="mb-10 rounded-2xl border border-amber-200/70 bg-amber-50/60 p-5 text-sm leading-relaxed text-slate-600">
              <strong className="font-semibold text-slate-800">An honest note:</strong> we're building our real
              project photo library as jobs are completed and customers give permission to share. The images below
              are clearly labelled <em>concept images</em> — they show the style and standard of finish we deliver,
              not completed North Ember Painting projects. Real project photos will replace them as they're supplied.
            </div>
          </Reveal>
          <Gallery items={portfolio} />
          <Reveal className="mt-12">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-500">
              Want to see what your project could look like? Call or message any time at{" "}
              <a href={site.phoneHref} className="font-semibold text-ember-dark">{site.phone}</a> or request a free
              estimate.
            </p>
          </Reveal>
        </div>
      </section>
      <CTA title="Your project could be next" />
    </>
  );
}
